import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`aptaxadjust/detail/${obj.taxadjkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor','vendorcode', 'po', 'postgroup', 'posting', 'tagihandp'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/aptaxadjust/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'aptaxadjust.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor', 'vendorcode', 'po', 'postgroup', 'posting', 'tagihandp'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
            }
                const url = `/aptaxadjust${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/apinv/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/apinv/postgroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("aptaxadjust", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`aptaxadjust/posting/${obj.taxadjkey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`aptaxadjust/unposting/${obj.taxadjkey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.taxadjkey);
                url = `/aptaxadjust/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.taxadjkey);
                url = `/aptaxadjust/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`aptaxadjust/${obj.taxadjkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};